import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const timeOptions = [
  '6:00 AM', '7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM', '11:00 AM',
  '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM',
  '6:00 PM', '7:00 PM', '8:00 PM', '9:00 PM'
];

const ServiceAppointments = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [product, setProduct] = useState(null);

  useEffect(() => {
    if (id) {
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/service_details_by_id/${id}`)
        .then(res => res.json())
        .then(data => setProduct(data));
    }
  }, [id]);

  useEffect(() => {
    // Parse query params from URL
    const params = new URLSearchParams(location.search);
    const urlDate = params.get('date');
    const urlStartTime = params.get('startTime');
    const urlEndTime = params.get('endTime');
    if (urlDate) setDate(urlDate);
    if (urlStartTime) setStartTime(urlStartTime);
    if (urlEndTime) setEndTime(urlEndTime);
  }, [location.search]);

  const handleSearch = (e) => {
    e.preventDefault();
    // Validate date is not less than today
    const today = new Date();
    today.setHours(0,0,0,0);
    const selectedDate = date ? new Date(date + 'T00:00:00') : null;
    if (!selectedDate || selectedDate < today) {
      alert('Please select a valid date that is today or later.');
      return;
    }
    const dayOfWeek = date
      ? selectedDate.toLocaleDateString('en-US', { weekday: 'long' })
      : '';
    navigate(`/search_vendors/${id}?dayOfWeek=${dayOfWeek}&startTime=${startTime}&endTime=${endTime}&date=${date}`);
  };

  return (
    <div style={styles.pageBg}>
      <div className="container mt-5">
        <button
          className="btn mb-3"
          style={styles.backBtn}
          onClick={() => product && product[0] && navigate(`/service_customer_details/${product[0].service_id}`)}
        >
          ← Back
        </button>
        <div className="card shadow-lg mx-auto" style={styles.card}>
          {product && product[0].image_url && (
            <div style={styles.imageContainer}>
              <img
                src={product[0].image_url}
                alt={product[0].name}
                style={styles.image}
              />
            </div>
          )}
          <div className="card-body">
            <h2
              className="card-title text-center mb-4 text-primary"
              style={styles.title}
            >
              {product && product[0].name ? `Search for ${product[0].name}` : 'Search Service'}
            </h2>
            {product && (
              <div className="mb-3 text-center">
                <p className="text-muted mb-2" style={styles.desc}>{product[0].description}</p>
                {product[0].appointment_links && (
                  <div style={styles.linkContainer}>
                    <label className="form-label fw-bold" style={styles.linkLabel}>
                      Appointment Link:
                    </label>
                    <a 
                      href={product[0].appointment_links} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={styles.appointmentLink}
                    >
                      {product[0].appointment_links}
                    </a>
                  </div>
                )}
              </div>
            )}
            <form onSubmit={handleSearch}>
              <div className="mb-3">
                <label className="form-label fw-bold">Select Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  onChange={e => setDate(e.target.value)}
                  style={styles.input}
                />
              </div>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label fw-bold">Start Time</label>
                  <select
                    className="form-select"
                    value={startTime}
                    onChange={e => setStartTime(e.target.value)}
                    style={styles.input}
                  >
                    <option value="">Select start time</option>
                    {timeOptions.map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </div>
                <div className="col">
                  <label className="form-label fw-bold">End Time</label>
                  <select
                    className="form-select"
                    value={endTime}
                    onChange={e => setEndTime(e.target.value)}
                    style={styles.input}
                  >
                    <option value="">Select end time</option>
                    {timeOptions.map(opt => (
                      <option key={opt} value={opt}>{opt}</option>
                    ))}
                  </select>
                </div>
              </div>
              <button type="submit" className="btn btn-success w-100 fw-bold" style={styles.searchBtn}>
                Search
              </button>
              <br/>
              <br/>
              <br/>
              {/* <span  style={styles.card}>All schedules are based on US Eastern Time Zone</span> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  pageBg: {
    minHeight: '100vh',
    background: 'linear-gradient(120deg, #f5f6fa 0%, #e3e6f3 100%)',
    paddingBottom: '40px',
  },
  card: {
    maxWidth: 800,
    minWidth: 400,
    borderRadius: 24,
    background: '#fff',
    padding: '32px 32px 24px 32px',
    boxShadow: '0 4px 24px rgba(25,118,210,0.13)',
  },
  backBtn: {
    background: '#333',
    color: '#fff',
    border: 'none',
    fontWeight: 'bold',
    borderRadius: '6px',
    padding: '10px 22px',
    marginBottom: '18px',
    boxShadow: '0 1px 4px #b3c6e6',
  },
  imageContainer: {
    width: '100%',
    height: '200px',
    maxHeight: '200px',
    overflow: 'hidden',
    borderTopLeftRadius: '0.5rem',
    borderTopRightRadius: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f6fa'
  },
  image: {
    width: 'auto',
    height: '100%',
    maxHeight: '120px',
    objectFit: 'contain',
    borderTopLeftRadius: '0.5rem',
    borderTopRightRadius: '0.5rem'
  },
  title: {
    fontSize: '1.3rem',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
  },
  desc: {
    fontSize: '1.05rem',
    color: '#555',
    fontStyle: 'italic',
    marginBottom: '0',
  },
  input: {
    borderRadius: '10px',
    fontSize: '1.15rem',
    padding: '14px 18px',
    minHeight: '48px',
  },
  searchBtn: {
    fontSize: '1.25rem',
    borderRadius: '10px',
    marginTop: '18px',
    padding: '16px 0',
    boxShadow: '0 2px 8px #c8e6c9',
    fontWeight: 'bold',
  },
  linkContainer: {
    marginTop: '16px',
    padding: '12px',
    background: '#f8f9fa',
    borderRadius: '8px',
    border: '1px solid #e9ecef',
  },
  linkLabel: {
    color: '#4078c0',
    fontSize: '0.95rem',
    marginBottom: '6px',
    display: 'block',
  },
  appointmentLink: {
    color: '#388e3c',
    textDecoration: 'none',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    wordBreak: 'break-all',
  },
};

export default ServiceAppointments;